var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen"},[_c('i',{staticClass:"sz",class:_vm.isFullscreen?'szln_quanpingtuichu':'szquanping',on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }